import React, { useEffect, useReducer, useState } from 'react';
import './Tutorial.css';
import { createUnityVisualizerInstance } from '../misc/helpers';
import GameManager from '../core/GameManager';
import TutorialScenario from '../scenarios/MainMenu/tutorialScenario';
import InGameUI from './InGameUI';
import ReactTools from '../core/Misc/ReactTools';
import ReactSoundManager from '../core/ReactSoundManager';
const reducer = (state: any, action: any) => {
	var result = ReactTools.generalReducer(state, action);
	switch (action.type) {
	case 'setWindow':
		result = {...state, currentWindow: action.value};
		break; 
	case 'forceUpdate':
		result = {...state, forceUpdate: !state.forceUpdate};
		break; 
	}
	return result;
};

const Tutorial = (props: any) => {
	const [isScenarioLoaded, setIsScenarioLoaded] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		gameManager: null,
		forceUpdate: false
	});
	
	useEffect(() => {
		if(state.gameManager) {
			if(!isScenarioLoaded) {
				state.gameManager.loadScenario('tutorial');
			}
			setIsScenarioLoaded(true);
		} else {
			var gm = new GameManager();
			gm.customData = {
				dispatch: dispatch
			};
			var environment = createUnityVisualizerInstance(gm);
			environment.init();
			var soundManager = new ReactSoundManager(() => {
				dispatch({
					type: 'forceUpdate',
					value: gm
				});
			});
			gm.init([
				new TutorialScenario(gm, 'tutorial')
			], environment, soundManager, true, '', {});
			dispatch({
				type: 'setGameManager',
				value: gm
			});
		}
	}, [state.gameManager, state.forceUpdate]);
	return (
		state.gameManager ? (
			<div>
				{state.gameManager.environment.render(() => {
					dispatch({
						type: 'forceUpdate'
					});
				}, {updateWindow: props.updateWindow})}
				<InGameUI updateWindow={props.updateWindow} gameManager={state.gameManager}></InGameUI>
			</div>) : (<div>Initialing Page...</div>)
	);
};

export default Tutorial;
